// Work that must reach the server while the session is still valid, run by
// JWTContext.logout() before the tokens are cleared (e.g. releasing My desk,
// CU-869fmcc9r, so calls stop ringing for someone who has signed out).
// Each task is best effort and bounded: logout never waits longer than
// BEFORE_LOGOUT_TIMEOUT_MS and never fails because a task did.

export const BEFORE_LOGOUT_TIMEOUT_MS = 2000;

const tasks = new Set();

// Returns the unregister function.
export const registerBeforeLogout = (task) => {
    tasks.add(task);
    return () => tasks.delete(task);
};

export const runBeforeLogout = async ({ timeoutMs = BEFORE_LOGOUT_TIMEOUT_MS } = {}) => {
    if (!tasks.size) return;
    const all = Promise.allSettled([...tasks].map((task) => Promise.resolve().then(task)));
    let timer;
    const timeout = new Promise((resolve) => { timer = setTimeout(resolve, timeoutMs); });
    try {
        await Promise.race([all, timeout]);
    } finally {
        clearTimeout(timer);
    }
};
